import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import pmsWarning from '../../img/pms/pms-warning.png'
import styles from './PmsPopup.module.scss'

const PmsPopup = () => {
  const [show, set] = useState(false)
  const currentPms = useSelector(s => s.login.subsidiaryPMS)

  return (
    <div
      onMouseOver={() => set(true)}
      onFocus={() => set(true)}
      onMouseLeave={() => set(false)}
      className={styles.container}
    >
      <div className={styles.imgContainer}>
        <img src={pmsWarning} alt="pmsWarning" />
      </div>
      {show && (
        <div className={styles.card}>
          <p>
            Your PMS isn&#39;t linked. Don&#39;t forget to sync for optimized results.
          </p>
          <Link to={currentPms === 'opera' ? '/operaSetup' : '/onboarding'}>
            <button className={styles.primaryButton}>Enable PMS sync</button>
          </Link>
        </div>
      )}
    </div>
  )
}

export default PmsPopup
